import React, { Component } from 'react';
import Image from 'app/utils/image';
import gesturesHandlerConstructor from './gesturesHandler';

// These are templates created within Amplience. DO NOT change values.
const initialPageLoadQuality = '$pdp-img-gallery$';
const onInteractionWithImageZoom = '$pdp-img-gallery-zoom$';

export const fullSizeTemplate = onInteractionWithImageZoom;

class ImageZoomer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      transformationTemplate: props.isFullSize ? onInteractionWithImageZoom : initialPageLoadQuality,
    };

    this.containerRef = React.createRef();

    this.helper = gesturesHandlerConstructor({
      scales: {
        fixedZoom: 2,
        max: 10,
        min: 1,
      },
    });
  }

  componentDidMount() {
    const { isInteractive } = this.props;
    if (!isInteractive) {
      return;
    }

    this.helper.updateProps({
      containerRef: this.containerRef,
    });
    const containerDom = this.containerRef.current;
    containerDom.addEventListener('mousedown', this.helper.handleMouseDown);
    containerDom.addEventListener('mousemove', this.helper.handleMouseMove);
    containerDom.addEventListener('mouseup', this.helper.handleMouseUp);
    containerDom.addEventListener('mouseleave', this.helper.handleMouseLeave);
    containerDom.addEventListener('touchstart', e => {
      this.setState({ transformationTemplate: onInteractionWithImageZoom });
      this.helper.handleTouchStart(e);
    });
    containerDom.addEventListener('click', () => this.setState({ transformationTemplate: onInteractionWithImageZoom }));
    containerDom.addEventListener('touchmove', this.helper.handleTouchMove);
    containerDom.addEventListener('touchend', this.helper.handleTouchEnd);
  }

  render() {
    const { src, alt, sizes, isInteractive } = this.props;
    const { transformationTemplate } = this.state;

    return (
      <div className={`image-zoomer${isInteractive ? '' : ' image-zoomer--static'}`} ref={this.containerRef}>
        <Image className="image-zoomer__image" media={{ url: src, transformationTemplate }} sizes={sizes} alt={alt} />
      </div>
    );
  }
}

ImageZoomer.defaultProps = {
  isFullSize: false,
  isInteractive: true,
  sizes: { s: '90vw', l: '40vw' },
};

export default ImageZoomer;
